import { FC } from "react";

import { BasicTwoLines } from "@components/for_drawer/BasicTwoLines";

import { ResourceSummaryModel } from "@resource/models";

import { SectionMetadata } from "./SectionMetadata";
import { SectionRelationship } from "./SectionRelationship";

interface Props {
  resourceSummary: ResourceSummaryModel;
}

export const ResourceDetailsDrawer: FC<Props> = ({ resourceSummary }) => {
  return (
    <div
      className={`grid w-full max-w-[500px] grid-cols-2 gap-4 sm:w-fit`}
      data-testid="resource-metadata-details"
    >
      <SectionMetadata data={resourceSummary} />

      {resourceSummary.metadata?.length > 0 ? <BasicTwoLines /> : null}

      <SectionRelationship data={resourceSummary.relationships} />
    </div>
  );
};
